

<template>
  <div class="dashboard">
     <MicrosoftComp />
  </div>
</template>

<script >
import MicrosoftComp from '@/components/MicrosoftComp.vue'

export default{
  components: {
    MicrosoftComp
  }
}
</script>